import { Element } from './Element';
import { ElementInterface } from "./interfaces/ElementInterface";
import {DateTime} from "luxon";
import { SchemaSettings } from "@api/models/objects/SchemaSettings";

export class Event extends Element {
    static readonly LocalizableField: Array<keyof Event> = ['title', 'subtitle'];
    static readonly FillableFields: Array<keyof Event> = ['title', 'subtitle', 'beginAt', 'endAt', 'updatedAt', 'stageFileId', 'partnerIds']

    title: string;
    description: string;
    viewParams: Record<string, Record<string, string | number | boolean>>;

    beginAt: DateTime;
    endAt: DateTime;
    backgroundFileId: string;
    stageFileId: string;
    partnerIds: string[];

    constructor(data: ElementInterface, schema = 'Events') {
        super(data, schema, ['beginAt', 'endAt']);
    }


    static getSchemaSettings(schemaId = '') {
        if (!schemaId) {
            schemaId = process.env.VUE_APP_EVENTS_SCHEMA! || 'Events';
        }
        return new SchemaSettings(schemaId, Event.LocalizableField, Event.FillableFields);
    }
}


export const EventListFields = ['id', 'title', 'subtitle', 'beginAt', 'endAt', 'viewParams', 'imageFileId', 'description', 'speakers', 'backgroundFileId', 'partnerIds', 'stageFileId', 'registrationType'];